import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge taught the product theme's own scale names
 * (`@nt/tokens/theme.css`), so a caller's class replaces the primitive's
 * instead of both landing in the DOM and the stylesheet order deciding:
 * `h-auto` beats `h-control`, `shadow-none` beats `shadow-card`,
 * `rounded-control` beats `rounded-pill`, `text-sm` beats `text-compact`,
 * and one `type-*` role replaces another.
 */
const twMerge = extendTailwindMerge<"type-role">({
  extend: {
    theme: {
      spacing: ["control", "control-x", "cell-x", "cell-y"],
      radius: ["control", "card", "menu", "panel", "pill"],
      shadow: [
        "card",
        "card-hover",
        "chip",
        "node",
        "panel",
        "drop",
        "focus",
        "button",
        "fill",
        "thumb",
      ],
      text: ["compact", "2xs", "3xs"],
    },
    classGroups: {
      "type-role": [
        "type-display",
        "type-h2",
        "type-h3",
        "type-title",
        "type-lead",
        "type-body",
        "type-small",
        "type-label",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
